import { getFromStorage, saveToStorage } from '../../../../DAL/storage-provider';
import { ICartData, ICartDataSerialized, IExtraCartData } from '../interfaces';

export const CART_STORAGE_KEY = 'cart-data';
export const CART_STORAGE_KEY_EXTRA = 'cart-data-extra';

/**
 * https://wavesaudio.atlassian.net/browse/DSWEB-3344
 */
export const removeCartDataStorage = () => {
    window.sessionStorage.removeItem(CART_STORAGE_KEY);
    window.sessionStorage.removeItem(CART_STORAGE_KEY_EXTRA);
};

/**
 * save cart data like 'address' to session storage;
 * the address should be saved to session storage in the following cases:
 * - on page load, if the preloaded data has address, and session storage doesn't have it
 * - when user edits address fields on the third step
 */
export const saveCartDataToStorage = (cartData: ICartData) => {

    // if the cart is empty --> do nothing
    if(!cartData ||
        !cartData.cartItems ||
        cartData.cartItems.length <= 0 ||
        !cartData.billingAddress ||
        cartData?.billingAddress?.addressPersonalName?.includes('OrdersManualCharge')) return;

    // addressId should not be saved to storage
    // as security consideration

    const billingAddress = {
        ...cartData.billingAddress,
        addressID: undefined,
    };

    const shippingAddress = cartData.shippingAddress ? {
        ...cartData.shippingAddress,
        addressID: undefined,
    } : undefined;

    const serialized: ICartDataSerialized = {
        billingAddress,
        shippingAddress,
    };

    saveToStorage('session-storage', CART_STORAGE_KEY, serialized);
};

/**
 * restore cart data like address from session storage;
 * the address should be restored in the following cases:
 * - on page load if session storage has address (and it should rewrite the preloaded data)
 */
export const restoreCartDataFromStorage = () => {

    const data = getFromStorage('session-storage', CART_STORAGE_KEY);
    if(!data) return null;

    let parsed: ICartDataSerialized|null = null;

    try{
        parsed = JSON.parse(data);
    }
    catch(ex){}

    return parsed;
};

export const saveExtraCartDataToStorage = (extraData: IExtraCartData) => {

    if(!extraData) return;

    saveToStorage('session-storage', CART_STORAGE_KEY_EXTRA, extraData);
};

export const restoreExtraCartDataFromStorage = () => {

    const data = getFromStorage('session-storage', CART_STORAGE_KEY_EXTRA);
    if(!data) return null;

    let parsed: IExtraCartData|null = null;

    try{
        parsed = JSON.parse(data);
    }
    catch(ex){}

    return parsed;
};